import React, { SVGProps } from 'react';

const TrashRedCircleIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width="26" height="26" rx="13" fill="#E45858" />
            <g clipPath="url(#clip0_12499_3898)">
                <path
                    d="M19.4173 8.625C19.4173 8.14175 19.0256 7.75 18.5423 7.75H16.3397C15.9711 6.70429 14.9844 6.00355 13.8757 6H12.1257C11.0169 6.00355 10.0303 6.70429 9.66166 7.75H7.45898C6.97574 7.75 6.58398 8.14175 6.58398 8.625C6.58398 9.10825 6.97574 9.5 7.45898 9.5H7.75066V16.7917C7.75066 18.5636 9.18708 20 10.959 20H15.0423C16.8142 20 18.2507 18.5636 18.2507 16.7917V9.5H18.5423C19.0256 9.5 19.4173 9.10825 19.4173 8.625ZM16.5007 16.7917C16.5007 17.5971 15.8477 18.25 15.0423 18.25H10.959C10.1536 18.25 9.50066 17.5971 9.50066 16.7917V9.5H16.5007V16.7917Z"
                    fill="white"
                />
                <path
                    d="M11.543 16.5C12.0262 16.5 12.418 16.1082 12.418 15.625V12.125C12.418 11.6418 12.0262 11.25 11.543 11.25C11.0597 11.25 10.668 11.6418 10.668 12.125V15.625C10.668 16.1082 11.0597 16.5 11.543 16.5Z"
                    fill="white"
                />
                <path
                    d="M14.459 16.5C14.9422 16.5 15.334 16.1082 15.334 15.625V12.125C15.334 11.6418 14.9422 11.25 14.459 11.25C13.9757 11.25 13.584 11.6418 13.584 12.125V15.625C13.584 16.1082 13.9757 16.5 14.459 16.5Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_12499_3898">
                    <rect width="14" height="14" fill="white" transform="translate(6 6)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default TrashRedCircleIcon;
